import { useMemo } from 'react'
import { type CommentProps } from './CommentCard'
import { type RequestComment } from './revisionRequest'
import { cellLinkFor } from './reviewComments'

// The Conversation tab's comments: plain conversation comments plus the
// cell comments (labelled with their cell), oldest first.
export function useReviewTimeline(comments: CommentProps[], cellComments: RequestComment[]): CommentProps[] {
  return useMemo(
    () => [
      ...comments,
      ...cellComments.map((c) => ({
        id: c.id, author: c.author, author_avatar_url: c.author_avatar_url, body: c.body, at: c.at, on: c.cell_label ?? null, cell: cellLinkFor(c),
        mine: c.mine, kind: 'review' as const,
      })),
    ].sort((a, b) => a.at.localeCompare(b.at)),
    [comments, cellComments]
  )
}
